import { observer } from 'mobx-react';
import ChatLoadingDots from './ChatLoadingDots';
import { Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../Translations';
import { StreamingAndReceivingInput, Streaming } from '../../../../ChatStores/ChatStore/Types';

interface Props {
  chatState: Streaming | StreamingAndReceivingInput;
}

function Loading({ chatState }: Props) {
  return (
    <>
      {chatState.retries === 1 ? (
        <div className="h-full flex items-center justify-center p-4">
          <div className="w-full max-w-lg mx-auto">
            <div className="p-4 bg-white shadow-md rounded-lg border border-gray-300 flex flex-col items-center">
              <Typography variant="bodyMedium" as="span">
                <T kind="I hit a snag generating the collection preview with updated recommendations. Retrying now..." />
              </Typography>
              <ChatLoadingDots />
            </div>
          </div>
        </div>
      ) : (
        <ChatLoadingDots />
      )}
    </>
  );
}

export default observer(Loading);
